import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import config from 'cfg';
import { loadLeagueWidgets, loadTeamWidgets, loadEventWidgets, loadPlayerWidgets } from '../loaders';
import { setWidgets, setInfo } from '../actions';
import _ from 'lodash';
import { loadPortfolio } from '../../portfolio/actions';
import auth from 'dash-front/auth';

const hocLoadGenerator = (loader, key, propName) =>
    compose(
        connect(
            ({ widgetPicker }) => ({
                widgets: widgetPicker.widgets[key] || [],
            }),
            { setWidgets, setInfo },
        ),
        lifecycle({
            componentWillReceiveProps(nextProps) {
                const { setWidgets, setInfo } = this.props;
                const templateWasChanged = nextProps.template && nextProps.template !== this.props.template;
                if ((nextProps[propName] && this.props[propName] !== nextProps[propName]) || templateWasChanged) {
                    loader(nextProps).then(({ widgets, data }) => {
                        setWidgets(widgets, key);
                        setInfo(data, key);
                    });
                }
                if (this.props[propName] && !nextProps[propName]) {
                    setInfo(null, key);
                }
            },
            componentDidMount() {
                const { setWidgets, setInfo } = this.props;

                if (this.props[propName]) {
                    loader(this.props)
                        .then(({ widgets, data }) => {
                            setWidgets(widgets, key);
                            setInfo(data, key);
                        })
                        .catch(e => {
                            // handel load error
                            console.log('EE', e);
                            setWidgets([], key);
                            setInfo(null, key);
                        });
                }
            },
            componentWillUnmount() {
                // const { setInfo } = this.props;
                // setInfo(null, key);
            },
        }),
    );

export const withLeagueWidgets = hocLoadGenerator(
    ({ tournamentId }) => loadLeagueWidgets(tournamentId),
    'league',
    'tournamentId',
);

export const withTeamWidgets = hocLoadGenerator(({ teamId }) => loadTeamWidgets(teamId), 'team', 'teamId');
export const withEventWidgets = hocLoadGenerator(({ eventId }) => loadEventWidgets(eventId), 'event', 'eventId');
export const withPlayerWidgets = hocLoadGenerator(
    ({ tournamentId, teamId, playerId }) => loadPlayerWidgets(tournamentId, teamId, playerId),
    'player',
    'playerId',
);

export const withAllWidgets = hocLoadGenerator(({ template }) => loadAllWidgets(template), 'all', 'allwidgets');

const profileWidgetToPortfolio = widget => {
    return {
        id: widget.wid,
        props: widget.props,
        category: [widget.category],
        spec: {
            social: true,
            widgetGroup: widget._id,
        },
        key: widget._id,
    };
};

export const withPortfolioWidgets = compose(
    connect(
        ({ portfolio }, { type = 'default' }) => ({
            widgets: _.get(portfolio, `byIds[${type}].widgets`, []).map(profileWidgetToPortfolio),
        }),
        { loadPortfolio },
    ),
    lifecycle({
        componentWillReceiveProps(nextProps) {
            if (nextProps.type !== this.props.type) {
                this.props.loadPortfolio(nextProps.type);
            }
        },
        componentDidMount() {
            const { type = 'default' } = this.props;

            this.props.loadPortfolio(type);
        },
    }),
);

const transformDemoToWidget = widget => {
    return {
        id: widget.spec.id,
        props: _.get(widget, 'spec.demo[0].props', {}),
        spec: _.omit(widget.spec, 'propTypes'),
        category: widget.spec.v2Categories || [],
        name: widget.name,
        key: `wid-${widget.spec.id}`,
        demoURL: widget.demoURL,
    };
};

export const loadAllWidgets = template => {
    return Promise.all([
        fetch(
            `${
                config.dash.api.host
            }/api/widgets/spec?social=true&template=${template}&access_token=${auth.getAccessToken()}`,
        )
            .then(response => response.json())
            .then(res => res.widgets || []),
    ]).then(([widgets]) => {
        return {
            widgets: (widgets || []).map(transformDemoToWidget),
            data: 'OK',
        };
    });
};

export const announments = (matches, category) => {
    return matches.map(event => ({
        id: 'MatchAnnouncement',
        props: {
            eventId: event.eventId,
        },
        spec: {
            social: true,
            widgetGroup: event.eventId,
        },
        category: [category],
        key: `an-${event.eventId}`,
    }));
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/hoc/widgets.js
 **/